import { API_BASE_URL_WITH_SLASH } from '../api/config.js';

export const DEFAULT_API_BASE_URL = API_BASE_URL_WITH_SLASH;
export const CCL_API_BASE_URL = DEFAULT_API_BASE_URL;
export const COMPANY_API_BASE_URLS = {};

export const normalizeCompanyCode = () => '';

export const resolveApiBaseUrl = () => DEFAULT_API_BASE_URL;

export const getStoredApiBaseUrl = () => DEFAULT_API_BASE_URL;

export const getApiBaseUrl = () => getStoredApiBaseUrl();

export const setApiBaseUrlForCompany = () => DEFAULT_API_BASE_URL;

export const resetApiBaseUrl = () => DEFAULT_API_BASE_URL;

export const getCurrentCompanyCode = () => '';

export const getWebSocketBaseUrl = () => {
  try {
    const url = new URL(DEFAULT_API_BASE_URL);
    url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
    url.pathname = '/ws/';
    url.search = '';
    url.hash = '';
    return url.toString();
  } catch (error) {
    return 'wss://atrux-717ecf8763ea.herokuapp.com/ws/';
  }
};

export const BASE_URL = {
  toString: getApiBaseUrl,
  valueOf: getApiBaseUrl,
  [Symbol.toPrimitive]: getApiBaseUrl,
};

export default BASE_URL;
